import React from 'react';

import Item from '@r1-frontend/ui-react/organisms/OrderSummary/Item';
import { TOrderSummaryComponent, TOrderSummaryItem } from '@r1-frontend/ui-react/organisms/OrderSummary/types';

import * as S from '../styled';

interface IItems {
    items: (TOrderSummaryItem | TOrderSummaryComponent)[],
}

export const OrderLines = ({ items }: IItems) => {
    return <S.Section>
        {items.map((item, idx) => {
            if ('props' in item && 'Component' in item) {
                const Component = item.Component;

                return <Component key={`orderListComponent_${idx}`}{...item.props} />;
            } else {
                return <Item key={`orderListItem_${item.title}`} {...item}/>;
            }
        })}
    </S.Section>;
};
